export enum Platform {
    LOCAL = 'local',
    MICROSOFT = 'microsoft',
}
